/**
 * Formats a Date object as a local-date string (YYYY-MM-DD) without converting
 * to UTC. Using toISOString() shifts midnight local time back by the UTC offset,
 * causing a one-day-behind bug in UTC+ timezones (e.g. UTC+5:30 Mumbai).
 *
 * Example:
 *   toISOString() on 2026-03-25 00:00 IST → "2026-03-24T18:30:00.000Z" ❌
 *   toLocalDateString() on same date      → "2026-03-25"               ✅
 */
export const toLocalDateString = (date: Date): string => {
    const year  = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day   = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
